import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do orthodontists compete with Invisalign GPs?",
    "a": "Specialist positioning — board certification, finishing quality, complex cases. Pages that show what an orthodontist does that a GP can't convert adult Invisalign shoppers at premium fees."
  },
  {
    "q": "Is Google Ads worth it for ortho?",
    "a": "Yes — Invisalign especially. Case values justify CPCs and we build campaigns with consult-to-start tracking."
  },
  {
    "q": "How do we drive kid and teen starts?",
    "a": "Parent-focused content, school-year scheduling, and family discounts on dedicated kids pages. Parents research for months before they call."
  },
  {
    "q": "How important is the consult experience?",
    "a": "Decisive. Conversion happens between the search and the chair. Online booking, intake forms, and same-week consult availability drive close rate."
  },
  {
    "q": "Do you handle multi-location ortho groups?",
    "a": "Yes — each location gets its own page, GBP, and local SEO so each ranks in its neighborhood Map Pack."
  }
];

export const Route = createFileRoute("/orthodontist-marketing-colorado")({
  head: () =>
    industryMarketingHead("Orthodontist", "orthodontic practice", "orthodontist-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Orthodontist"}
      industryLower={"orthodontic practice"}
      slug={"orthodontist-marketing-colorado"}
      subheadline={"We help Colorado orthodontists fill the chair with Invisalign, braces, and child/teen ortho starts — without depending on dental referrals alone."}
      painPoints={["Invisalign GPs are eating into adult case volume","Your site looks the same as every other ortho in town","Consultation no-show rate is too high"]}
      serviceDescriptions={{
        seo: "Rank for braces, Invisalign, clear aligners, kids ortho, adult ortho, and every ortho service across every Colorado market.",
        googleMaps: "Own 'orthodontist near me' in the Map Pack with reviews that drive consults.",
        webDesign: "Case-specific pages — Invisalign, braces, kids, adults — with smile galleries and online consult booking.",
        ppc: "High-margin Google Ads for adult Invisalign and aligner starts with strong ROAS.",
        geoAi: "Get cited when shoppers ask ChatGPT 'best orthodontist in Denver' or 'Invisalign near me'.",
        socialMedia: "Smile-transformation content that builds trust and converts the consult.",
      }}
      testimonial={{"quote":"Adult Invisalign starts doubled. We finally have a marketing engine that doesn't depend on GP referrals.","role":"Orthodontist & Practice Owner","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Orthodontic marketing in Colorado Springs","description":"Drive Invisalign and braces starts across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Orthodontic marketing in Denver","description":"Compete in Denver's saturated ortho market."},{"to":"/castle-rock-digital-marketing","label":"Orthodontic marketing in Castle Rock","description":"High-value adult Invisalign across Castle Rock and Douglas County."}]}
    />
  ),
});
